import gql from 'graphql-tag';
import { checkSavedLogInData, logOut } from '@/aws-api';
import { apolloClient } from '@/vue-apollo';
// eslint-disable-next-line import/no-cycle
import router from '@/router';

async function getUserData(username) {
  return (await apolloClient.query({
    query: gql`
      query ($username: String!) {
        users_by_pk(id: $username) {
          company {
            id
            uuid
            owner_id
            enabled_features
            add_users_limit
            name
            invoices(limit: 1, order_by: {paid_until: desc}) {
              paid_until
            }
          }
          suspended
          time_zone
          update_ref_id
        }
      }
    `,
    variables: {
      username,
    },
  })).data.users_by_pk;
}

function transformCognitoResult(cognitoUser) {
  return {
    username: cognitoUser.username,
    givenName: cognitoUser.attributes.given_name,
    familyName: cognitoUser.attributes.family_name,
    email: cognitoUser.attributes.email,
    isEmailVerified: cognitoUser.attributes.email_verified,
    groups: cognitoUser.signInUserSession.accessToken.payload['cognito:groups'] || [],
    jwtExp: cognitoUser.signInUserSession.idToken.payload.exp,
  };
}

function transformDbResult(data) {
  return {
    company: data.company
      ? {
        id: data.company.id,
        uuid: data.company.uuid,
        name: data.company.name,
        enabledFeatures: data.company.enabled_features,
        ownerId: data.company.owner_id,
        invoices: data.company.invoices,
        add_users_limit: data.company.add_users_limit,
      }
      : null,
    suspended: data.suspended,
    timeZone: data.time_zone,
    updateRefId: data.update_ref_id,
  };
}

export default {
  namespaced: true,
  state() {
    return {
      user: null,
    };
  },
  getters: {
    isLoggedIn(state) {
      return state.user != null;
    },
    isCompanyHasAccess(state) {
      const paidUntil = state?.user?.company?.invoices[0]?.paid_until;
      return paidUntil && (new Date(paidUntil) > Date.now());
    },
    isAdmin(state, getters) {
      return state.user && getters.isLoggedIn && state.user.groups.includes('Admin');
    },
    isCompanyAdmin(state, getters) {
      return state.user && !getters.isAdmin && state.user.username === state.user.company?.ownerId
      && state.user.groups.includes('Client-admin');
    },
    jwtTokenExp(state) {
      const jwtexp = state?.user?.jwtExp;
      return jwtexp;
    },
    username(state) {
      return state?.user?.username;
    },
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload;
    },
  },
  actions: {
    async logIn({ commit }, cognitoUser) {
      const userData = {
        ...transformCognitoResult(cognitoUser),
        ...transformDbResult(await getUserData(cognitoUser.username)),
      };
      commit('setUser', userData);
    },
    async restore({ dispatch }) {
      const cognitoUser = await checkSavedLogInData();

      if (cognitoUser == null) return;

      await dispatch('logIn', cognitoUser);
    },
    async reload({ dispatch }) {
      await dispatch('restore');
    },
    async logOut({ commit }) {
      await logOut();
      commit('setUser', null);
      await router.push('/login');
    },
  },
};
